<template>
  <div class="form-check form-check-custom form-check-solid" :class="customClass">
    <input
        :disabled="disabled"
        :checked="modelValue === value"
        :value="value"
        :name="name"
        :id="id"
        :class="size"
        class="form-check-input"
        type="radio"
        @input="$emit('update:modelValue', value)"
    />
    <label class="form-check-label" :for="id" v-html="placeholder"></label>
  </div>
</template>

<script>
export default {
  name: 'RadioField',
  props: {
    placeholder: null,
    modelValue: null,
    value: null,
    disabled: Boolean,
    class: String,
    name: String,
    type: {
      type: String,
      default: 'radio'
    },
    id: String,
    size: String
  },
  computed: {
    customClass() {
      return [this.class, this.type === 'checkbox' ? 'checkbox-style' : 'radio-style'];
    }
  }
}
</script>

<style scoped>
.radio-style .form-check-input {
  border-radius: 50%;
}

.checkbox-style .form-check-input {
  border-radius: 5px;
}

.checkbox-style .form-check-input:checked {
  --bs-form-check-bg-image: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 11%27 width=%2713%27 height=%2711%27 fill=%27none%27%3e%3cpath d=%27M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z%27 fill=%27%23ffffff%27/%3e%3c/svg%3e);
}

.checkbox-style .form-check:not(.form-switch) .form-check-input {
  background-size: 60% 60%;
}
</style>